import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

  constructor() {
    window.scrollTo(0, 0);
   }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }

}
